<template>
    <section>
        <div class="container pb-5">
            <b-row>
                <b-col cols="12">
                    <strong>BaseUrl:</strong>
                    <p>{{ licenseDetails.baseUrl }}</p>
                    <strong>Version:</strong>
                    <p>{{ licenseDetails.version }}</p>
                </b-col>
            </b-row>
        </div>
    </section>
</template>

<script>
import LicenseService from '@/services/LicenseService.js'

export default {
    data () {
        return {
            licenseDetails: {}
        }
    },
    methods: {
        async fetchLicenseDetails () {
            this.licenseDetails = LicenseService.GetLicenseDetails()
        }
    },
    created () {
        this.fetchLicenseDetails()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/License.vue